module.exports = __webpack_public_path__ + "63f1a52efa0c41a601a560b7a5a2e222.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/painted-nails-blue-s.png
// module id = 2517
// module chunks = 0